<div class="container-fluid mt-3">
  <p-panel
    header="フィルター"
    [toggleable]="true"
    [collapsed]="false">
    <form
      [formGroup]="filterForm"
      (ngSubmit)="onFilterChange()">
      <div class="grid p-fluid">
        <div class="col-12 md:col-6 lg:col-3">
          <div class="field">
            <label
              for="targetDateRange"
              class="block mb-2">
              対象日
            </label>
            <p-select
              inputId="targetDateRange"
              [options]="targetDateRangeOptions"
              formControlName="targetDateRange"
              optionLabel="label"
              optionValue="value"
              placeholder="全て"
              [showClear]="true"
              class="w-full"></p-select>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="field">
            <label
              for="lastUpdateDateRange"
              class="block mb-2">
              最終更新日
            </label>
            <p-select
              inputId="lastUpdateDateRange"
              [options]="lastUpdateDateRangeOptions"
              formControlName="lastUpdateDateRange"
              optionLabel="label"
              optionValue="value"
              placeholder="全て"
              [showClear]="true"
              class="w-full"></p-select>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="field">
            <label
              for="storeAreaIds"
              class="block mb-2">
              エリア
            </label>
            <p-multiselect
              inputId="storeAreaIds"
              [options]="availableStoreAreas"
              formControlName="storeAreaIds"
              optionLabel="name"
              optionValue="id"
              placeholder="全て選択"
              display="chip"
              [showClear]="true"
              class="w-full"></p-multiselect>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="field">
            <label
              for="storeType"
              class="block mb-2">
              種別
            </label>
            <p-select
              inputId="storeType"
              [options]="storeTypeOptions"
              formControlName="storeType"
              optionLabel="label"
              optionValue="value"
              placeholder="全て"
              [showClear]="true"
              class="w-full"></p-select>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="field">
            <label
              for="chainNames"
              class="block mb-2">
              チェーン名
            </label>
            <p-multiselect
              inputId="chainNames"
              [options]="chainOptions"
              formControlName="chainNames"
              placeholder="全て選択"
              display="chip"
              [showClear]="true"
              class="w-full"></p-multiselect>
          </div>
        </div>
        <!-- Buttons moved to a new row and aligned -->
      </div>
      <div class="grid p-fluid mt-3">
        <!-- Added mt-3 for spacing -->
        <div class="col-12 md:col-6 flex justify-content-start">
          <!-- Use flex for horizontal alignment, md:col-6 to restrict width on medium screens and up -->
          <button
            pButton
            type="submit"
            class="p-button-primary mr-2">
            <i
              class="pi pi-filter"
              aria-hidden="true"></i>
            絞り込み
          </button>
          <button
            pButton
            type="button"
            class="p-button-secondary"
            (click)="resetFilters()">
            <i
              class="pi pi-times"
              aria-hidden="true"></i>
            リセット
          </button>
        </div>
      </div>
    </form>
  </p-panel>

  @if (isLoading) {
    <div class="text-center mt-3">
      <p-progressspinner
        class="w-4rem h-4rem"
        strokeWidth="8"
        animationDuration=".5s"></p-progressspinner>
    </div>
  }

  @if (!isLoading && stores.length === 0) {
    <div class="mt-3">
      <p-message severity="info">該当するデータが見つかりませんでした。</p-message>
    </div>
  }

  @if (!isLoading && stores.length > 0) {
    <div class="mt-3">
      <div class="table-header-sticky-outer">
        全{{ stores.length.toLocaleString() }}件
        <p-table
          showGridlines
          [value]="stores"
          [paginator]="true"
          [rows]="200"
          [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
          [tableStyle]="{ 'min-width': '50rem' }"
          class="p-datatable-striped p-datatable-gridlines table-header-sticky">
          <ng-template #header>
            <tr>
              <th pSortableColumn="type">
                種別
                <p-sorticon field="type"></p-sorticon>
              </th>
              <th pSortableColumn="targetDate">
                対象日
                <p-sorticon field="targetDate"></p-sorticon>
              </th>
              <th pSortableColumn="storeArea.name">
                エリア
                <p-sorticon field="storeArea.name"></p-sorticon>
              </th>
              <th pSortableColumn="chainName">
                チェーン名
                <p-sorticon field="chainName"></p-sorticon>
              </th>
              <th pSortableColumn="storeName">
                店舗名
                <p-sorticon field="storeName"></p-sorticon>
              </th>
              <th style="width: 20%">URL</th>
              <!-- Added width to header for consistency -->
              <th pSortableColumn="lastUpdate">
                最終更新日
                <p-sorticon field="lastUpdate"></p-sorticon>
              </th>
              <th>備考</th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-store>
            <tr [ngClass]="store.type === 'OPEN' ? 'open-row' : 'close-row'">
              <td>
                <p-badge
                  [value]="store.type"
                  [severity]="store.type === 'OPEN' ? 'danger' : store.type === 'CLOSE' ? 'secondary' : null"
                  class="custom-badge"></p-badge>
              </td>
              <td>{{ store.targetDate | date: 'yyyy/MM/dd' }}</td>
              <td>{{ store.storeArea?.name }}</td>
              <td>{{ store.chainName }}</td>
              <td>{{ store.storeName }}</td>
              <td style="max-width: 250px; word-break: break-all; white-space: normal">
                <a
                  [href]="store.url"
                  target="_blank"
                  rel="noopener noreferrer">
                  {{ store.url }}
                </a>
              </td>
              <td>{{ store.lastUpdate | date: 'yyyy/MM/dd HH:mm' }}</td>
              <td>{{ store.note }}</td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="8">データが見つかりません。</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>
